import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { DurusKaydiEditComponent } from './durus-kaydi-edit.component';
import { DurusKaydiKartComponent } from './durus-kaydi-kart.component';

@DinamikBilesen({
  id: 'durus-kaydi',
  baslik: 'Duruş Kaydı',
  aciklama: 'Duruş kaydı ekle',
  ikon: 'pause-circle',
  kategori: 'uretim',
})
class DurusKaydi {
  paylas_kutusu = DurusKaydiEditComponent;
  paylasilmis_kart = DurusKaydiKartComponent;
}
